import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiMenu, FiX, FiHome } = FiIcons;

const PublicPageLayout = ({ title, subtitle, children, activePage = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const navLinks = [
    { label: 'Hvordan det fungerer', path: '/hvordan-fungerer-det' },
    { label: 'Regelverk', path: '/regelverk-og-etterlevelse' },
    { label: 'Karriere', path: '/karriere' },
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 flex flex-col">
      <header className="bg-white/95 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <div className="w-9 h-9 bg-[#1E40AF] rounded-lg flex items-center justify-center shadow-sm">
              <SafeIcon icon={FiShield} className="text-white text-lg" />
            </div>
            <h1 className="text-lg font-bold tracking-tight text-[#0F172A]">HMSVarsling</h1>
          </div>
          
          <nav className="hidden md:flex items-center space-x-6 text-[15px] font-medium text-[#64748B]">
            <button onClick={() => navigate('/')} className="flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full hover:bg-blue-100 transition-colors font-bold">
              <SafeIcon icon={FiHome} /> Hjem
            </button>
            {navLinks.map((link) => (
              <button key={link.path} onClick={() => navigate(link.path)} className={`hover:text-[#1E40AF] transition-colors ${activePage === link.path ? 'text-[#1E40AF] font-semibold' : ''}`} >
                {link.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <button onClick={() => navigate('/company/register')} className="bg-[#1E40AF] text-white px-5 py-2 rounded-lg font-bold text-sm hover:bg-[#1E3A8A] transition-colors shadow-sm">
              Kom i gang
            </button>
            <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="text-xl" />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-grow">
        {title && (
          <div className="bg-[#F8FAFC] border-b border-gray-100 py-16">
            <div className="max-w-4xl mx-auto px-4 text-center">
              <h1 className="text-3xl md:text-5xl font-black text-slate-900 mb-4">{title}</h1>
              {subtitle && <p className="text-lg text-slate-500">{subtitle}</p>}
            </div>
          </div>
        )}
        {children}
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex justify-center gap-8 mb-8 text-sm font-bold text-white">
            <button onClick={() => navigate('/partner/login')}>Partner Portal</button>
            <button onClick={() => navigate('/seller/login')}>Selger Portal</button>
            <button onClick={() => navigate('/superadmin/login')}>Intern Portal (Admin)</button>
          </div>
          <p className="text-xs">© {new Date().getFullYear()} HMSVarsling. Alle rettigheter reservert.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicPageLayout;